export default [
    {
        path: '/states',
        name: 'states',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/States.vue')
    }
]